import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import {HorizontalBar} from 'react-chartjs-2';
import Typography from '@material-ui/core/Typography';
import { styles } from '../CSS/Styles';
import {money_convert} from '../../util/StringUtil';
// chart template
// on default, it contains color code, and can be configure in the colorScheme.

// need to pass in :
//            h6 : the tile of the chart, in a list, one element is one row
//            data  : in following format:

//            const data = {
//                labels: [['x-axis label1 row1','x-axis label1 row2'], 
//                         ['x-axis label2 row1','x-axis label2 row2'], 
//                         ['x-axis label3 row1','x-axis label3 row12']],
//                datasets: [
//                    {
//                        stack:'stack1',
//                        label: 'Controls of Assurance',
//                        backgroundColor: setting.COLOR.AMBER,
//                        borderWidth: 0,
//                        data: controlAssuranceCount
//                    },{
//                        stack:'stack1',
//                        label: 'Total Assurance',
//                        backgroundColor: setting.COLOR.BRIGHTYELLOW,
//                        borderWidth: 0,
//                        data: [column1,
//                               column2,
//                               column3]
//                    }
//                ]
//            };

class horizontalChart extends Component {

    render() {
        const { classes } = this.props
        let data = this.props.data

        let option = {
            plugins: {
                datalabels: {
                    display: false
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        callback: function(label, index, labels) {
                            return money_convert(label,'m')
                        }
                    },
                    scaleLabel: {
                        display: false,
                        labelString: 'Amount'
                    }
                }]
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        //console.log("1st chart data is "+data.datasets[0].data[tooltipItem.index])
                        var value = data.datasets[0].data[tooltipItem.index];
                        if(parseInt(value) >= 1000){
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            return '$' + value;
                        }
                    }
                } // end callbacks:
            }, //end tooltips
            title:{
                display:false,
                text: "Top 5 Awarded Suppliers by Award Value",
            },
            legend:{
                position:"bottom",
                display: false
                },
        }

        return (
            <div className={classes.details}>
                <HorizontalBar data={data} height={100} options={option}/>
            </div>
        )
    }
}
export default withStyles(styles)(horizontalChart);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/horizontalChart.js